import React, { useEffect, useRef } from "react";
import { animate, motion } from "framer-motion";

const variants = {
  onscreen: {
    transition: { staggerChildren: 0.15 }
  }
};

const childerVariants = {
  offscreen: {
    y: 50,
    opacity: 0
  },
  onscreen: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 }
    }
  },
};

const TimelineText = ({ 
  number, 
  titleBefore,
  titleColored,
  titleAfter,
  text,
  isCurrent 
}) => {
  const coloredBackground = useRef();

  useEffect(() => {
    if(isCurrent){
      animate(coloredBackground.current, { scaleX: 1 }, { duration: 1, type: 'spring' });
    }
    else{
      animate(coloredBackground.current, { scaleX: 0 }, { duration: 1, type: 'spring' });
    }
  }, [isCurrent]);

  return(
    <motion.div variants={variants} className="timeline-text">
      <motion.span className="timeline-number" variants={childerVariants}>{number}</motion.span>
      <motion.div variants={childerVariants}>
        <h3 style={{ whiteSpace: 'break-spaces' }}>
          {titleBefore}
          <div style={{ position: "relative", display:'inline-flex', zIndex: 2 }}>
            <motion.span
              ref={coloredBackground}
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
                backgroundColor: "rgb(147, 64, 255)",
                paddingInline: 10,
                zIndex: -1
            }} />
            {titleColored}
          </div>
          {titleAfter}
        </h3>
      </motion.div>
      <motion.p variants={childerVariants}>{text}</motion.p>
    </motion.div>
  );
};

export default TimelineText;